module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptust311-2560x1440.8becccc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptust311-2560x1440.jpg
// module id = 1011
// module chunks = 37